module.exports = __webpack_public_path__ + "defaultVideo.6e396622.png";